import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToasts } from "react-toast-notifications";
import AnalysisForm from "../common/AnalysisForm"
import AnalysisResult from './AnalysisResult';

export default function InputBox(props) {
  const { addToast } = useToasts();
  const [result, setResult] = useState(null);
  
  function onResult(text, res) {
      console.log("result", res);
      if (!res || res.errorType){
        setResult(null)
        addToast(`System error: Unable to analyze.`, { appearance: "error" });
      } else {
        addToast("Success", { appearance: "success" });
        setResult({text, result: res});
      }
  }

  return (
    <div className="card mb-4">
      <div className="card-header">
        <FontAwesomeIcon icon="pen-alt" className="mr-1" />
        Manual Input
      </div>
      <div className="card-body">
        <AnalysisForm engine='comprehend' onResult={(text, res)=> onResult(text, res)} /> 
        {result ? <div><hr/><AnalysisResult result={result} /> </div>: null}
      </div>
    </div>
  );
}
